export const GET_WORKER_QUERY_KEY = "get-worker-query-key";

/**
 * Backend main endpoint:
 * There is a known design misconception that /agentProfile endpoint returns 200 with empty string as response during onboarding
 * It doesn't crash the app, but it's not a valid response so it fails zod validation and shows error boundary in development environment
 * This is blocking the app from loading in the onboarding flow and raises questions for developers about why this is happening
 * We should fix this endpoint to return 404 when agent is not found
 *
 * Worker bff endpoint:
 * When user is onboarding, the endpoint returns 404, which is not a valid response
 * This will be fixed during onboarding revamp - we will detect onboarding state and call a different endpoint instead (or none)
 */
export const ONBOARDING_USER_ERROR = "User is still onboarding - fetching profile is not possible";

export const WORKER_STAGE_QUERY_KEY = "worker-stage-query-key";
